export default __webpack_public_path__ + "static/media/document-outline.5575e7cd.svg";